<template lang="pug">
.re-turnstile(ref="container")
</template>

<script>
const TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js'

let scriptPromise = null

function loadTurnstileScript() {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile)
  }
  if (scriptPromise) {
    return scriptPromise
  }
  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${TURNSTILE_SRC}"]`)
    const onReady = () => {
      if (window.turnstile) {
        resolve(window.turnstile)
      } else {
        reject(new Error('Turnstile failed to load'))
      }
    }
    if (existing) {
      existing.addEventListener('load', onReady)
      existing.addEventListener('error', () => reject(new Error('Turnstile failed to load')))
      return
    }
    const script = document.createElement('script')
    script.src = TURNSTILE_SRC
    script.async = true
    script.defer = true
    script.addEventListener('load', onReady)
    script.addEventListener('error', () => reject(new Error('Turnstile failed to load')))
    document.head.appendChild(script)
  })
  return scriptPromise
}

export default {
  name: 'Turnstile',

  props: {
    sitekey: {
      type: String,
      default: () => import.meta.env.VITE_TURNSTILE_SITEKEY,
    },
    size: {
      type: String,
      default: 'flexible',
    },
    theme: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    widgetId: null,
  }),

  mounted() {
    this.renderWidget()
  },

  beforeDestroy() {
    this.remove()
  },

  methods: {
    renderWidget() {
      loadTurnstileScript().then((turnstile) => {
        if (this._isDestroyed || this._isBeingDestroyed || !this.$refs.container) {
          return
        }
        this.widgetId = turnstile.render(this.$refs.container, {
          sitekey: this.sitekey,
          size: this.size,
          theme: this.theme || (this.$vuetify.theme.dark ? 'dark' : 'light'),
          callback: (token) => {
            this.$emit('verified', token)
          },
          'expired-callback': () => {
            this.$emit('expired')
          },
          'error-callback': () => {
            this.$emit('error')
          },
        })
      }).catch(() => {
        this.$emit('error')
      })
    },

    reset() {
      if (window.turnstile && this.widgetId !== null) {
        window.turnstile.reset(this.widgetId)
      }
    },

    remove() {
      if (window.turnstile && this.widgetId !== null) {
        window.turnstile.remove(this.widgetId)
        this.widgetId = null
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.re-turnstile
  display flex
  justify-content center
</style>
